import { Component, HostBinding, OnInit } from '@angular/core';
import { AuthConfigService } from '@argalis-apps/angular-core';
import { MainConfigService } from '@argalis-apps/angular-global';
import { MUser } from '@argalis-apps/models';
import { Router } from '@angular/router';
import packageJson from '../../../../../../package.json';

@Component({
  selector: 'app-argalis-apps-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {
  @HostBinding('class') themeFlag: string;

  public userConnected: MUser.CUser | null = null;
  public dialogOpened = false;
  public changePasswordPopupMode = true;
  public typeUser: MUser.ETypeUser = MUser.ETypeUser.FORMATEUR;
  public goToRoute = ['/'];
  public logoOf: any;
  public version: string;

  constructor(
    private router: Router,
    private authConfigService: AuthConfigService,
    private mainConfig: MainConfigService,
  ) {}

  ngOnInit() {
    this.version = packageJson.version;
    this.themeFlag = `${this.themeFlag || ''} ${this.authConfigService.themingClassName}`;
    this.userConnected = null;
    this.mainConfig.getLogoOf().subscribe(
      (logo)=> {
        this.logoOf = logo.data;
      }
    );
  }

  changePasswordPopup(user: any) {
    if (user.user.password_renew) {
      this.userConnected = user.user;
    }
  }
  changePasswordReponse(isChanged: boolean) {
    if (!isChanged) {
      this.userConnected = null;
    }
    this.router.navigate(this.goToRoute);
  }
}
